export default function NotFound() {
  return (
    <div
      className="mt-[78px] overflow-x-auto hide-scrollbar overflow-visible max-w-[1180px] mx-auto"
      data-testid="not-found">
      <h2
        className="
         text-4xl md:text-[84px] md:leading-tight my-20 md:mt-36 mx-4 tb:mx-0 font-normal text-transparent w-fit
            bg-clip-text bg-gradient-to-r from-[#0666EA] to-[#FB71AE]
          ">
        Page not Found
      </h2>
    </div>
  )
}
